"use client";

import { BrandMark } from "@/components/brand-mark";
import { backendBaseUrl } from "@/lib/config";

type LoginFormProps = {
	returnTo?: string;
};

export function LoginForm({ returnTo }: LoginFormProps) {
	const login = () => {
		const url = new URL(`${backendBaseUrl}/auth/saml/login`);
		// Absolute, because the backend only honours a return_to on one of this
		// environment's own hosts and treats a bare path as "go to the main app" - which
		// dropped the page a 401 was raised on, and would send a sign-in started on
		// BoReferences's own host (#374) to the chat instead.
		const destination = new URL(returnTo ?? "/", window.location.origin);
		url.searchParams.set("return_to", destination.toString());
		window.location.href = url.toString();
	};

	return (
		<div className="flex min-h-screen flex-col bg-borenius-paper md:flex-row">
			{/* Brand panel */}
			<div className="flex flex-col justify-between gap-10 bg-borenius-red px-10 py-10 text-borenius-accent-contrast md:w-[42%] md:max-w-[460px] md:px-12 md:py-12">
				<div className="flex items-center gap-2.5">
					<BrandMark size={30} tone="inverted" />
					<span className="text-[17px] font-semibold">Borenius AI</span>
				</div>
				<div>
					<h2 className="font-display text-3xl font-medium leading-tight md:text-[2rem]">
						The firm's assistant for drafting, research and reasoning.
					</h2>
					<p className="mt-3.5 max-w-md text-sm leading-relaxed text-borenius-accent-contrast/80">
						Built for confidential client and legal work — answers you can read,
						trust, and trace back to their sources.
					</p>
				</div>
				<p className="font-mono text-[10.5px] uppercase tracking-[0.08em] text-borenius-accent-contrast/70">
					Borenius Attorneys Ltd · Internal use only
				</p>
			</div>

			{/* Sign-in */}
			<div className="flex flex-1 animate-rise flex-col items-center justify-center px-6 py-12 sm:px-14">
				<div className="w-full max-w-sm">
					<h1 className="font-display text-2xl font-semibold text-borenius-ink">
						Sign in
					</h1>
					<p className="mt-1.5 text-sm leading-relaxed text-borenius-muted">
						Use your Borenius account to continue.
					</p>

					<button
						type="button"
						onClick={login}
						className="mt-7 flex w-full items-center justify-center gap-2.5 rounded-lg bg-borenius-ink px-4 py-3 text-sm font-semibold text-borenius-paper transition hover:opacity-90 active:scale-[0.99]"
					>
						<span className="flex h-[18px] w-[18px] items-center justify-center rounded-sm bg-borenius-paper text-[11px] font-bold text-borenius-ink">
							M
						</span>
						Continue with Microsoft
					</button>

					<div className="mt-6 flex items-start gap-2.5 rounded-lg bg-borenius-surface-alt px-3.5 py-3">
						<span className="text-sm">🔒</span>
						<p className="text-[11.5px] leading-relaxed text-borenius-muted">
							Sessions are encrypted and tied to your firm identity. Client
							material never leaves the firm's tenant.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
